function capitalizeFirstLetter(string) {
	const s = string?.charAt(0)?.toUpperCase() + string?.slice(1);
	return s?.replaceAll("%20", " ");
}

export default capitalizeFirstLetter;
